export function storytellingInit() {
	document.querySelectorAll('.is-style-media-text-parallax .wp-block-media-text__media img').forEach(function(img) {
		var imgParent = img.parentElement;
	
		function parallaxImg() {
			var speed = 1;
			var imgY = imgParent.getBoundingClientRect().top + window.scrollY;
			var winY = window.scrollY;
			var winH = window.innerHeight;
			var parentH = imgParent.clientHeight;
		  
			// Reverse the calculation to make image move up when scrolling up
			var imgMovement = (winY - imgY) * speed;
		
			// Max number of pixels until block disappear
			var imgTop = winH + parentH;
		
			// Percentage between start showing until disappearing
			var imgPercent = (imgMovement / imgTop) * 100 - (50 - (speed * 50));

			// Apply the calculated position to the image
			img.style.top = imgPercent + '%';
		}
	
		// Listen to scroll and ready events
		function onScrollOrReady() {
		parallaxImg();
		}
	
		window.addEventListener('scroll', onScrollOrReady);
		document.addEventListener('DOMContentLoaded', onScrollOrReady);
	});
}